import './polyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from 'devextreme/core/config';

import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { loadMessages } from 'devextreme/localization';

import { msalConfig } from './AuthConfig';
import AuthGate from './components/auth-gate/AuthGate';
import enMessages from './localization/en.json';

import { licenseKey } from './devextreme-license';

config({ licenseKey });

// The sign-in page is displayed before <App /> (which loads the messages) is mounted.
loadMessages(enMessages);

export const publicClientApplication = new PublicClientApplication(msalConfig);

publicClientApplication.initialize().then(() => {
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );

    root.render(
        <MsalProvider instance={publicClientApplication}>
            <AuthGate>
                <App />
            </AuthGate>
        </MsalProvider>);

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
});
